import { useContext } from "react"
import { EditorToolbarButton, EditorToolbarTray } from "./EditorToolbarUI";

import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const EditorFormatTray = ({context}) => {
    const { editor, editorState } = useContext(context);

    return (
        <EditorToolbarTray>
            <EditorToolbarButton
                icon={<MaterialIcon name='format_bold' weight={300}/>}
                active={editorState.isBold}
                onClick={() => editor.chain().focus().toggleBold().run()}
            />
            <EditorToolbarButton
                icon={<MaterialIcon name='format_italic' weight={300}/>}
                active={editorState.isItalic}
                onClick={() => editor.chain().focus().toggleItalic().run()}
            />
            <EditorToolbarButton
                icon={<MaterialIcon name='format_underlined' weight={300}/>}
                active={editorState.isUnderline}
                onClick={() => editor.chain().focus().toggleUnderline().run()}
            />
            <EditorToolbarButton
                icon={<MaterialIcon name='format_strikethrough' weight={300}/>}
                active={editorState.isStrike}
                onClick={() => editor.chain().focus().toggleStrike().run()}
            />
        </EditorToolbarTray>
    )
}